import isActionConfirmationsEnabled from '../selectors/isActionConfirmationsEnabled';
import { updateUserOptions, updateUserConfiguration } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';

export default async function saveActionConfirmationsOption() {
    updateUserOptions({ ShowNotificationBar: isActionConfirmationsEnabled() });
    const userOptions = getUserConfiguration().UserOptions;

    await updateUserConfiguration([
        {
            propertyName: 'ShowNotificationBar',
            propertyType: 'Boolean',
            propertyValue: `${userOptions.ShowNotificationBar}`,
        },
    ]);
}
